export default function ContainerCard(props) {
  return (
    <div className={`py-2 px-2 mx-4 md:mx-10 rounded-xl ${props.className}`}>
      {props.children}
    </div>
  );
}
